module.exports = __webpack_public_path__ + "static/medika1-image-1-05919e83fa941cbbe45368075b24d09e.png";